import "../styles/home/Section2.css";

const Section2Network = () => {
  return (
    <section
      className="htmlblock"
      style={{ backgroundColor: "white", minHeight: "0px" }}
    >
      <div className="container">
        <div className="row">
          <div className="col-md-5">
            <h2 style={{ margin: "0", color: "black" }}>WHAT OTHERS SAY </h2>
          </div>
          <br />
          <br />
          <br />
          <br />
          <div className="col-md-5">
            <h2 style={{ margin: "0", color: "black" }}>WHAT THE MEDIA SAY </h2>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Section2Network;
